import React from 'react';
import { MOBILE_SCREEN } from 'consts';
import { useMatchMedia } from 'hooks/useMatchMedia';
import { getIsIOS } from 'utils/getUserBrowserInfo';

import defaultImageProduct from 'assets/images/pictures/wilko/product-fallback.png';

import style from './mainImage.module.scss';

const isIOS = getIsIOS();

const MainImage = ({ item, consistentAltTag, productName, className }) => {
  const isMobile = useMatchMedia(`(max-width: ${MOBILE_SCREEN}px)`);

  if (isIOS) {
    return (
      <div className={style.mainImage}>
        <img
          className={className}
          src={
            item[isMobile ? 'medium' : 'large'] ||
            item.src ||
            defaultImageProduct
          }
          alt={item.alt_tag || consistentAltTag || productName}
        />
      </div>
    );
  }

  return (
    <div className={style.mainImage}>
      <picture>
        <source
          srcSet={item.webp?.[isMobile ? 'medium' : 'large']}
          type="image/webp"
        />
        <img
          className={className}
          src={
            item[isMobile ? 'medium' : 'large'] ||
            item.src ||
            defaultImageProduct
          }
          alt={item.alt_tag || consistentAltTag || productName}
        />
      </picture>
    </div>
  );
};

export default MainImage;
